import styled from 'styled-components';

import { essayStatusEnum } from './EssayItem';

export const Card = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--gray-90);
  border-radius: 8px;
  min-height: 351px;

  @media (max-width: 640px) {
    min-height: auto;
  }
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  line-height: 28.8px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 19.6px;
  margin-top: 8px;
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #caccce;

  @media (max-width: 640px) {
    max-width: unset;
  }
`;

export const DetailsButton = styled.button`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  line-height: 24px;
  border-top: 1px solid var(--dark-gray-line);
  padding: 16px 24px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  height: 100%;

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

export const ScoreLabel = styled.p`
  font-size: 18px;
  line-height: 19px;
`;

export const Score = styled.p`
  font-size: 80px;
  line-height: 1;
  font-weight: 700;

  span {
    display: inline-block;
    font-size: 16px;
    font-weight: normal;
    transform: translateY(-5px);
  }
`;

export const TagWrapper = styled.div<{ essayStatus: essayStatusEnum }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  span {
    display: block;
    font-size: 12px;
    line-height: 24px;
    color: var(--gray-01);
    background-color: ${(props) => {
      switch (props.essayStatus) {
        case essayStatusEnum.DONE:
          return `#9ee2b8`;
        case essayStatusEnum.DRAFT:
          return `#F2F2F3`;
        case essayStatusEnum.SENT:
          return `#FFE3AC`;
      }
    }};
    padding: 0 8px;
    border-radius: 4px;
  }
`;
